/* eslint-disable no-nested-ternary */
import React, { HTMLProps, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import moment from "moment-timezone";
import axios from "axios";
import { useScreenClass } from "react-grid-system";
import { useHistory } from "react-router-dom";
import { Col, Row } from "../components/StyledGridSystem";
import Breadcrumb from "../components/Breadcrumb";
import Card from "../components/Card";
import Table from "../components/Table";
import NullStateTR from "../components/NullStateTr";
import { StyledText, TextSize, TextStatus } from "../components/Text";
import FlexBox, { FlexGrow } from "../components/FlexBox";
import { RightAlign } from "../components/UtilsComponents";
import Button from "../components/Button";
import Icon from "../components/Icon";
import Status from "../types/enum/Status";
import theme from "../styles/theme";
import TermDropdown from "../components/TermDropDown";
import TermEditModal from "../components/TermEditModal";
import { EmptyTermContent, TermContent } from "../filter/FilterValue";
import SnackBar from "../components/SnackBar";
import TermDeleteModal from "../components/TermDeleteModal";
import { set } from "react-hook-form";

const RowStyled = styled.div`
  display: flex;
  flex-flow: column;
`;
function TermsPage() {
  const history = useHistory();
  useEffect(() => {
    fetchTerms();
  }, []);
  const screenClass = useScreenClass();
  const test = [{ name: "Terms", link: "/terms" }];
  const isMobile = useMemo(() => ["xs", "sm"].includes(screenClass), [
    screenClass,
  ]);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [currentTerm, setCurrentTerm] = useState<TermContent>(EmptyTermContent);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = (data: any) => {
    if (data) {
      setCurrentTerm(data);
      setIsModalOpen(true);
    }
  };
  const openEditModal = (data: any) => {
    if (data) {
      setCurrentTerm(data);
      setIsEditOpen(true);
      setMessage("");
    }
  };
  const openDeleteModal = (data: any) => {
    if (data) {
      setCurrentTerm(data);
      setDeleteOpen(true);
      setMessage("");
    }
  };
  const [loading, setLoading] = useState(true);
  const [isItem, setIsItem] = useState(false);
  const ColumnName = (isMobile: boolean) => {
    if (isMobile) {
      return (
        <>
          <th></th>
          <th></th>
        </>
      );
    }
    return (
      <>
        <th>Term Name</th>
        <th style={{ minWidth: 80 }}>Start</th>
        <th style={{ minWidth: 80 }}>End</th>
        <th>Course Add/Drop Start</th>
        <th>Course Add Deadline</th>
        <th>Course Drop Deadline</th>
        <th>Course Withdraw Deadline</th>
        <th>Is Open?</th>
        <th></th>
      </>
    );
  };
  const [terms, setTerms] = useState([
    {
      id: "",
      name: "",
      term_start: "",
      term_end: "",
      // add_course_start: "",
      // add_course_end: "",
      // withdraw_end: "",
      is_open: false,
      course_withdraw_deadline: "",
      course_drop_deadline: "",
      course_add_deadline: "",
      course_add_drop_start: "",
    },
  ]);
  const fetchTerms = () => {
    setLoading(true);
    axios
      .get("/api/v1/courses/terms")
      .then((res) => {
        if (res.data.data.terms) {
          setTerms(res.data.data.terms);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const createTerm = () => {
    const path = "/terms/create";
    history.push(path);
  };
  const closeEditModal = () => {
    setIsEditOpen(false);
    fetchTerms();
  };

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [message, setMessage] = useState("");

  return (
    <>
      {isEditOpen && (
        <TermEditModal
          isOpen={isEditOpen}
          setOpen={setIsEditOpen}
          currentTerm={currentTerm}
          onEditComplete={() => {
            closeEditModal();
            setSnackbarOpen(true);
          }}
          setMessage={setMessage}
        />
      )}
      {deleteOpen && (
        <TermDeleteModal
          isOpen={deleteOpen}
          setOpen={setDeleteOpen}
          currentTerm={currentTerm}
          onDeleteComplete={() => {
            closeEditModal();
            setSnackbarOpen(true);
          }}
        />
      )}
      <SnackBar
        isOpen={message !== "" && snackbarOpen}
        setOpen={setSnackbarOpen}
        type="success"
        message={message}
      />
      <Row>
        <Col>
          <Breadcrumb path={test} />
        </Col>
      </Row>
      <Row>
        <Col>
          <FlexBox space={2}>
            <h2 style={{ marginRight: "auto", marginBottom: 0 }}>Terms</h2>
            <p style={{ fontSize: "0.85rem"}}>
              <span style={{color:'red'}}>*</span>All dates are shown in <b>dd-mm-yyyy</b> format
            </p>
          </FlexBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={{ marginTop: "0px" }}>
            <FlexBox
              style={{
                alignItems: "flex-start",
                marginBottom: theme.spacing.base * 2,
              }}
            >
              <FlexGrow ml-auto style={{ marginLeft: "auto" }}>
                <RightAlign>
                  <Button
                    onClick={() => createTerm()}
                    isOutline
                    status={Status.primary}
                    style={{ padding: "4px 12px" }}
                  >
                    <Icon name="plus-s" mr={0.5} />
                    Create New Term
                  </Button>
                </RightAlign>
              </FlexGrow>
            </FlexBox>
            <Table hoverable>
              <thead>
                <tr>{ColumnName(isMobile)}</tr>
              </thead>
              <tbody>
                {!loading && terms ? (
                  terms.map((data) => {
                    if (!isMobile) {
                      return (
                        <tr key={data.id} onClick={() => openModal(data)}>
                          <td>
                            <StyledText textSize={TextSize.default}>
                              {data.name}
                            </StyledText>
                          </td>
                          <td>
                            {data.term_start
                              ? moment.utc(data.term_start).format("DD-MM-YYYY")
                              : "-"}
                          </td>
                          <td>
                            {data.term_end
                              ? moment.utc(data.term_end).format("DD-MM-YYYY")
                              : "-"}
                          </td>
                          <td>
                            {data.course_add_drop_start ===
                            "0001-01-01T00:00:00Z"
                              ? "-"
                              : moment
                                  .utc(data.course_add_drop_start)
                                  .format("DD-MM-YYYY")}
                          </td>
                          <td>
                            {data.course_add_deadline === "0001-01-01T00:00:00Z"
                              ? "-"
                              : moment
                                  .utc(data.course_add_deadline)
                                  .format("DD-MM-YYYY")}
                          </td>
                          <td>
                            {data.course_drop_deadline ===
                            "0001-01-01T00:00:00Z"
                              ? "-"
                              : moment
                                  .utc(data?.course_drop_deadline)
                                  .format("DD-MM-YYYY")}
                          </td>
                          <td>
                            {data.course_withdraw_deadline ===
                            "0001-01-01T00:00:00Z"
                              ? "-"
                              : moment
                                  .utc(data?.course_withdraw_deadline)
                                  .format("DD-MM-YYYY")}
                          </td>
                          <td>
                            {/* <Pill
                              style={{ textTransform: "capitalize" }}
                              status={Status.success}
                            ></Pill> */}
                            {data.is_open ? (
                              <Icon
                                // mr={1}
                                name="check-mark"
                                color="#4dd801"
                                size={3}
                                style={{ verticalAlign: "middle" }}
                              />
                            ) : (
                              <Icon
                                mr={1}
                                name="x-s"
                                color="orange"
                                size={2.25}
                                style={{ verticalAlign: "middle" }}
                              />
                            )}
                          </td>
                          <td
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            style={{ verticalAlign: "middle" }}
                          >
                            <TermDropdown
                              term={data}
                              openEditModal={openEditModal}
                              openDeleteModal={openDeleteModal}
                            />
                          </td>
                        </tr>
                      );
                    }

                    return (
                      <tr key={data.id}>
                        <td>
                          <RowStyled>
                            <StyledText style={{ fontWeight: "bold" }}>
                              {data.name}
                            </StyledText>
                            <StyledText status={TextStatus.muted}>
                              {data.term_start
                                ? moment(
                                    new Date(data.term_start).toISOString()
                                  )
                                    .utc()
                                    .format("DD-MM-YYYY")
                                : "-"}
                            </StyledText>
                            <StyledText status={TextStatus.muted}>
                              {data.term_end
                                ? moment(new Date(data.term_end).toISOString())
                                    .utc()
                                    .format("DD-MM-YYYY")
                                : "-"}
                            </StyledText>
                            <StyledText status={TextStatus.muted}>
                              {data.course_add_drop_start
                                ? moment(
                                    new Date(
                                      data.course_add_drop_start
                                    ).toISOString()
                                  )
                                    .utc()
                                    .format("DD-MM-YYYY")
                                : "-"}
                            </StyledText>
                            <StyledText status={TextStatus.muted}>
                              {data.course_add_deadline
                                ? moment(
                                    new Date(
                                      data.course_add_deadline
                                    ).toISOString()
                                  )
                                    .utc()
                                    .format("DD-MM-YYYY")
                                : "-"}
                            </StyledText>
                            <StyledText status={TextStatus.muted}>
                              {data.course_drop_deadline
                                ? moment(
                                    new Date(
                                      data.course_drop_deadline
                                    ).toISOString()
                                  )
                                    .utc()
                                    .format("DD-MM-YYYY")
                                : "-"}
                            </StyledText>
                          </RowStyled>
                        </td>
                        <td
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          style={{ verticalAlign: "middle" }}
                        >
                          <TermDropdown
                            term={data}
                            openEditModal={openEditModal}
                            openDeleteModal={openDeleteModal}
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <div></div>
                )}
                {isItem && !loading ? (
                  <NullStateTR>No term found.</NullStateTR>
                ) : (
                  <div></div>
                )}
              </tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default TermsPage;
